import Logger from './logger'
import Tracking from './tracking'
import adobeEventTagging from './adobeEventTagging'

export default {
  Logger,
  Tracking,
  adobeEventTagging,
}
